import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconDashSvg } from './IconDashSvg';

export type IconDashProps = UseIconProps;

export function IconDash(props: IconDashProps) {
  const iconProps = useIcon({ size: 'micro', ...props });

  return <Box tagName={IconDashSvg} {...iconProps} />;
}
